import { gql } from '@apollo/client';

export const FETCH_LMI_PROOF_DOCS = gql`
  query Flex_FetchLMIProofDocs($userId: Int!) {
    user(id: $userId) {
      lmiProofDocs {
        proofDocUrls
        proofDocName
        proofDocStatus
        uaLmiSourceTypeId
        utilityAccountId
        utilityAccountNumber
        utilityName
      }
    }
  }
`;
